import { useEffect, useState, FC, ReactNode } from 'react';
import { getBase, Themes, useTenantPermissions, useThemeContext } from '@maxtropy/components';
import { Spin } from 'antd';
import NotAuthorized from '../NotAuthorized';

interface AuthorizedPermissionProps {
  permissionKey: string | string[];
  children?: ReactNode;
  theme?: Themes;
}

const AuthorizedPermission: FC<AuthorizedPermissionProps> = props => {
  const { permissionKey, theme, children } = props;
  const [loading, setLoading] = useState<boolean>(true);
  const [state, setState] = useState(false);
  const { setCustomTheme } = useThemeContext();

  const permission = useTenantPermissions();
  useEffect(() => {
    setCustomTheme?.(theme);
    if (getBase()) {
      // 全局数据通信会向主应用和所有子应用发送数据
      window.microApp?.setGlobalData({ customTheme: theme });
    }

    return () => {
      setCustomTheme?.();
      if (getBase()) {
        window.microApp?.setGlobalData({ customTheme: undefined });
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [theme]);

  useEffect(() => {
    if (permission) {
      let state: boolean;
      if (Array.isArray(permissionKey)) {
        state = permissionKey.map(i => permission.includes(i)).some(i => i);
      } else {
        state = permission.includes(permissionKey);
      }
      setState(state);
      setLoading(false);
    }
  }, [permission, permissionKey]);

  return loading ? <Spin spinning={loading}></Spin> : state ? <>{children}</> : <NotAuthorized />;
};

export default AuthorizedPermission;
